import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteCustomFilterView, setCustomFilterView } from '../../../features/CustomFilterView/customFilterViewAction';
import { openSnackbar } from '../../../features/SnackBar/snackBarSlice';
import { hasAdvanceFilters } from '../../../sections/AccountList/accountListConfig';

function useCustomFilter(props) {
  const {
    selectedFilters,
    resetFilters,
    selectedView,
    setSelectedView,
    findSelectedView,
    setIsViewConfigEnabled,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUpdate = () => {
    const message = 'Successfully saved selected filters in current Account View';
    const errorMessage = 'Failed to update Account View';

    if (!selectedView) {
      dispatch(openSnackbar({ open: true, message: errorMessage, type: 'error' }));
      return;
    }

    const viewData = findSelectedView(selectedView);
    const toggleAdvanceFilter = hasAdvanceFilters(selectedFilters);

    if (!viewData) {
      dispatch(openSnackbar({ open: true, message: errorMessage, type: 'error' }));
      return;
    }

    const data = {
      id: viewData.id,
      filter: { ...selectedFilters, toggleAdvanceFilter },
    };

    dispatch(setCustomFilterView(data)).then((res) => {
      if (res?.payload?.status === 'SUCCESS') {
        dispatch(openSnackbar({ open: true, message, type: 'success' }));
        setIsViewConfigEnabled(false);
      } else {
        dispatch(openSnackbar({ open: true, message: errorMessage, type: 'error' }));
      }
    });
  };

  const handleSave = (values) => {
    const toggleAdvanceFilter = hasAdvanceFilters(selectedFilters);

    const data = {
      name: values?.name,
      alert: values?.alert,
      filter: { ...selectedFilters, toggleAdvanceFilter },
    };

    dispatch(setCustomFilterView(data)).then((res) => {
      if (res?.payload?.status === 'SUCCESS') {
        const message = 'Account View created successfully';
        dispatch(openSnackbar({ open: true, message, type: 'success' }));
        setIsViewConfigEnabled(false);
        setSelectedView(res.payload.data?.id);
        navigate(`/account-list/${res.payload.data?.id}`);
      } else {
        const errorMessage = 'Failed to create Account View';
        dispatch(openSnackbar({ open: true, message: errorMessage, type: 'error' }));
      }
    });
  };

  const handleEdit = (values) => {
    if (!selectedView) return;

    const viewData = findSelectedView(selectedView);

    if (!viewData) return;

    const data = {
      id: viewData.id,
      name: values.name,
      alert: values.alert,
      filter: viewData.filter,
    };

    dispatch(setCustomFilterView(data)).then((res) => {
      if (res?.payload?.status === 'SUCCESS') {
        const message = 'Custom Filter updated successfully';
        dispatch(openSnackbar({ open: true, message, type: 'success' }));
      } else {
        const errorMessage = 'Failed to update Custom Filter';
        dispatch(openSnackbar({ open: true, message: errorMessage, type: 'error' }));
      }
    });
  };

  const handleDelete = () => {
    const view = findSelectedView(selectedView);
    if (view) {
      dispatch(deleteCustomFilterView({ id: view.id })).then((res) => {
        if (res?.payload?.status === 'SUCCESS') {
          dispatch(openSnackbar({ open: true, message: 'Custom Filter deleted successfully', type: 'success' }));
          resetFilters();
        } else {
          dispatch(openSnackbar({ open: true, message: 'Failed to delete Custom Filter', type: 'error' }));
        }
      });
    }
  };

  const getInitialValues = () => {
    const viewData = findSelectedView(selectedView);
    return viewData
      ? {
        name: viewData.name,
        alert: viewData.alert,
      }
      : {
        name: '',
        alert: false,
      };
  };

  return {
    handleUpdate,
    getInitialValues,
    handleSave,
    handleEdit,
    handleDelete,
  };
}

export default useCustomFilter;
